<!-- email sending form -->
<!-- emailFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      // Radio buttons
      sendAsHtml: [true, Validators.required],
      title: ['', Validators.required],
      html: ['', Validators.required],
      text: ['', Validators.required],
      includeSignature: [false],
      sendAt: [new Date(), Validators.required]
    }); -->

    <div class="flex-div-parent">
        <form [formGroup]="emailFormGroup" class="email-form flex-div-child">
            <!-- <mat-form-field appearance="fill" class="email-form-field">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" required>
        <mat-error *ngIf="emailFormGroup.get('name').hasError('required')">Name is required</mat-error>
    </mat-form-field> -->

            <mat-form-field appearance="fill" class="email-form-field">
                <mat-label>Email to</mat-label>
                <input matInput formControlName="emailTo" required>
                <mat-error *ngIf="emailFormGroup.get('emailTo').hasError('required')">Email is required</mat-error>
                <mat-error *ngIf="emailFormGroup.get('emailTo').hasError('email')">Invalid email format</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="email-form-field">
                <mat-label>CC</mat-label>
                <input matInput formControlName="cc">
                <mat-error *ngIf="emailFormGroup.get('cc').hasError('email')">Invalid email format</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="email-form-field">
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subject" required>
                <mat-error *ngIf="emailFormGroup.get('subject').hasError('required')">Subject is required</mat-error>
            </mat-form-field>

            <div class="checkbox-group">
                <mat-checkbox formControlName="sendAsHtml" class="email-checkbox">Send as HTML</mat-checkbox>
                <mat-checkbox formControlName="includeSignature" class="email-checkbox">Include Signature</mat-checkbox>
            </div>

            <div class="radio-group">
                <mat-radio-group formControlName="signatureType" class="email-radio-group">
                    <mat-radio-button value="frigg">Frigg</mat-radio-button>
                    <mat-radio-button value="cuboid">Cuboid</mat-radio-button>
                </mat-radio-group>
            </div>

            <mat-form-field appearance="fill" class="email-form-field" *ngIf="!emailFormGroup.get('sendAsHtml').value">
                <mat-label>Title</mat-label>
                <input matInput formControlName="title" required>
                <mat-error *ngIf="emailFormGroup.get('title').hasError('required')">Title is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="email-form-field" *ngIf="!emailFormGroup.get('sendAsHtml').value">
                <mat-label>Text Content</mat-label>
                <textarea matInput formControlName="text" required></textarea>
                <mat-error *ngIf="emailFormGroup.get('text').hasError('required')">Text content is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="email-form-field" *ngIf="emailFormGroup.get('sendAsHtml').value">
                <mat-label>HTML Content</mat-label>
                <textarea matInput formControlName="html" required></textarea>
                <mat-error *ngIf="emailFormGroup.get('html').hasError('required')">HTML content is required</mat-error>
            </mat-form-field>

            <!--Add attachments -->
            <button type="button" mat-raised-button (click)="fileInput.click()">Choose File</button>
            <input hidden (change)="onFileSelected()" #fileInput type="file" id="file"
                accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif,.xls,.xlsx,.csv" multiple />
            <!-- accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif,.xls,.xlsx,.csv" -->

            <div class="attachments-list" *ngIf="attachments.length > 0">
                <table mat-table [dataSource]="attachments" class="attachments-table">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> File Name </th>
                        <td mat-cell *matCellDef="let attachment"> {{ attachment.file.name }} </td>
                    </ng-container>


                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef> Actions </th>
                        <td mat-cell *matCellDef="let attachment">
                            <button type="button" mat-icon-button (click)="downloadAttachment(attachment)"
                                *ngIf="attachment.url">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button type="button" mat-icon-button (click)="removeAttachment(attachment)">
                                <mat-icon>delete</mat-icon>
                            </button>

                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['name', 'actions']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['name', 'actions'];"></tr>
                </table>
            </div>
            <!-- <mat-error *ngIf="attachments.length === 0">No attachments selected</mat-error>
        <mat-error *ngIf="attachments.length > 5">You can only attach up to 5 files</mat-error>
        <mat-error *ngIf="attachments.length > 0 && attachments.some(file => file.size > 10485760)">
            Each attachment must be less than 10MB
        </mat-error>
        <mat-error *ngIf="attachments.length > 0 && attachments.some(file => !['image/png', 'image/jpeg', 'image/gif'].includes(file.type))">
            Only PNG, JPEG, and GIF files are allowed
        </mat-error>
        <mat-error *ngIf="attachments.length > 0 && attachments.some(file => file.name.length > 255)">
            Attachment names must be less than 255 characters
        </mat-error> -->


            <mat-checkbox formControlName="asap" class="email-checkbox">Send ASAP</mat-checkbox>

            <ng-container *ngIf="!emailFormGroup.get('asap').value">
                <mat-form-field appearance="fill" class="email-form-field">
                    <mat-label>Send At Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="sendAtDate" required>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="emailFormGroup.get('sendAtDate').hasError('required')">Send date is
                        required</mat-error>
                </mat-form-field>

                <div class="email-form-inline-fields" style="display: flex; gap: 16px; align-items: flex-end;">
                    <div style="flex: 1;">
                        <mat-form-field appearance="fill" class="email-form-field" style="width: 100%;">
                            <mat-label>Send At Hour</mat-label>
                            <mat-select formControlName="sendAtHour" required>
                                <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="emailFormGroup.get('sendAtHour').hasError('required')">Send hour is
                                required</mat-error>
                        </mat-form-field>
                    </div>
                    <div style="flex: 1;">
                        <mat-form-field appearance="fill" class="email-form-field" style="width: 100%;">
                            <mat-label>Send At Time</mat-label>
                            <mat-select formControlName="sendAtMinute" required>
                                <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="emailFormGroup.get('sendAtMinute').hasError('required')">Send time is
                                required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>


            <!-- <input class="form-control" type="time" value="16:35" name='startTime' (change)="onSetTime()" id="startTime"  step="3600" min="00:00" max="23:59" pattern="[0-2][0-9]:[0-5][0-9]"> -->
            <div class="button-group">
                <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="emailFormGroup.invalid">
                    Send Email
                </button>
                <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
            </div>
        </form>
        <div class="flex-div-child">
            <!--Mail Content Preview-->
            <div id="mailContentPreview" class="mail-content-preview">


            </div>

        </div>
    </div>
<ng-container *ngIf="loading">
    <app-spinner-loading></app-spinner-loading>
</ng-container>